import React from 'react';
import { Container } from 'reactstrap';

const RightService = () => {
    return (
        <>
        
        <div className="container-fluid px-5 mb-3" >
          
    
          <header className=" mt-3 pt-3">
            <h3>Right to Service Act 2014</h3>
    
          </header>
          <section className="content pb-3" style={{textAlign:'justify' }}>
            </section>
            </div>
            </>
    );
};

export default RightService;
